// Funkcje pomocnicze dla lexical_markdown_controller
// Wydzielone z kontrolera aby można było je testować jednostkowo (bez zależności od Lexical DOM)

// Konwersja markdown z Lexical → format storage
//
// rawMarkdown: surowy markdown z $convertToMarkdownString(TRANSFORMERS, undefined, true)
//   (shouldPreserveNewLines=true — dzięki temu Lexical zachowuje puste paragrafy jako \n)
//
// Odpowiada za:
// 1. unescape \_ → _ (Lexical escapuje underscores, co łamie np. Liquid {{api_token}})
// 2. normalizacja \r\n → \n
export function collapseMarkdown(rawMarkdown) {
  return rawMarkdown
    .replace(/\\_/g, "_")
    .replace(/\r\n/g, "\n")
}
